import { render } from "./HeroiconsSolidDotsVertical.vue?vue&type=template&id=cff6d19e"
const script = {}

import exportComponent from "C:\\laragon\\www\\idmex-api\\vendor\\laravel\\nova\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidDotsVertical.vue"]])

export default __exports__